import { NavLink } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';

import { DefaultLink } from 'hb-react/frontoffice/components/Link';

const EventMenu = ({
  appPages,
  defaultTitle = I18n.t('global.description'),
  slug,
}) => {
  const classes =
    'flush h4 inline-block soft soft-half--bottom ' +
    // classes above are required for network color usage
    'custom-border-color-outline-navigation-if-active';

  const activeStyle = {
    borderBottom: '2px solid #FD4329',
    color: '#353B42',
  };

  return (
    <Box
      as="nav"
      color="#717273"
      className="push--bottom"
      data-testid="event-menu"
    >
      <NavLink
        key="default"
        to=".."
        end
        className={slug === 'default' ? `${classes} active` : classes}
        style={slug === 'default' ? activeStyle : undefined}
        disabled={slug === 'default'}
        role="tab"
      >
        {defaultTitle}
      </NavLink>
      {appPages
        .map((page) => ({
          slug: page.menu.slug,
          name: page.menu.menu_name,
          openInNewTab: page.menu.open_in_new_tab,
          external: page.menu.external,
          url: page.menu.url,
        }))
        .map((page) =>
          page.external ? (
            <DefaultLink
              href={page.url}
              key={page.url}
              target={page.openInNewTab ? '_blank' : undefined}
              className="flush h4 inline-block soft soft-half--bottom"
              role={!page.openInNewTab ? 'tab' : undefined}
            >
              {page.name}
            </DefaultLink>
          ) : (
            <NavLink
              key={page.url}
              to={`${slug !== 'default' ? '../' : ''}page/${page.slug}`}
              className={slug === page.slug ? `${classes} active` : classes}
              style={slug === page.slug ? activeStyle : undefined}
              disabled={slug === page.slug}
              role="tab"
            >
              {page.name}
            </NavLink>
          ),
        )}
    </Box>
  );
};

export default EventMenu;
